import React, { useState, useEffect } from "react";
import { useRef } from "react";
import DropdownListItem from "./DropdownListItem";
import downIcon from "assets/icons/down-black.svg";
import useOnClickOutside from "hooks/useOnClickOutside";
import { useDispatch } from 'react-redux';
import {
  handleUpdateCateringAndMealCartCustomOption
} from "redux/actions";

const CateringDropdown = ({
  optionList = [],
  groupData,
  icon,
  lable = "",
  defaultValue,
  placeholder,
  iconTag,
  custom_options_arr,
  productIndex,
  setShowProductButton
}) => {
  const refDropdown = useRef();
  const dispatch = useDispatch()

  const { title: label, is_add_option_price, id: groupId,position } = groupData
  const [isShowDropdownOption, setIsShowDropdownOption] = useState(false);

  useOnClickOutside(refDropdown, () => setIsShowDropdownOption(false));

  const [selectedOptionValue, setSelectedOptionValue] = useState(defaultValue);
  const [selectedOptionTitle, setSelectedOptionTitle] = useState(defaultValue);

  useEffect(() => {

    const defaultSelectedOption = custom_options_arr.find(option => option.option_id === groupId)

    defaultSelectedOption && setSelectedOptionValue(defaultSelectedOption.id)
    defaultSelectedOption && setSelectedOptionTitle(defaultSelectedOption.value)
    // defaultSelectedOptionData && defaultSelectedOptionData[0] &&
    //   dispatch(handleUpdateCateringAndMealCustomOption({ [groupId]: [...updatedDefaultOptionList] }))

  }, [custom_options_arr]) // eslint-disable-line


  const handleChange = (optionValue, title, dropdownOption) => {
    setSelectedOptionValue(optionValue);
    setSelectedOptionTitle(title)

    const { id, option_id, price, value, is_multiply_option_price_against_base_price, is_add_option_price } = dropdownOption
    dispatch(handleUpdateCateringAndMealCartCustomOption({ [groupId]: [{ id, is_add_option_price, label, option_id, price, value, position, is_multiply_option_price_against_base_price }] }, productIndex, true))
    setShowProductButton()
  };
  return (
    <div className="show-items" ref={refDropdown}>
      <button onClick={() => setIsShowDropdownOption(!isShowDropdownOption)}>
        {icon && <img src={icon} alt="Icon" />}
        {iconTag && iconTag}
        {placeholder && !selectedOptionValue ? (
          <span>{placeholder}</span>
        ) : (
          <span>{`${lable} ${selectedOptionTitle}`}</span>
        )}

        <img src={downIcon} alt="downIcon" />
      </button>

      <div
        className={
          isShowDropdownOption
            ? "dropdown-align dropdown-show"
            : "dropdown-align dropdown-hidden"
        }
      >
        <div className="list-menu">
          <ul>
            {optionList.map((dropdownOption, index) => {
              return (
                <DropdownListItem
                  optionName={dropdownOption.title}
                  optionValue={dropdownOption.value}
                  onSelectOption={handleChange}
                  key={index}
                  onClose={() => setIsShowDropdownOption(false)}
                  selectedOptionValue={selectedOptionValue}
                  dropdownOption={{
                    ...dropdownOption.option,
                    is_multiply_option_price_against_base_price: dropdownOption.is_multiply_option_price_against_base_price,
                    is_add_option_price: dropdownOption.is_add_option_price,
                  }}
                />
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CateringDropdown;
